// extracted by mini-css-extract-plugin
export default {"main-content":"Returns_main-content__pPpDB","tableContainer":"Returns_tableContainer__AiehL","buttons":"Returns_buttons__GE6yd","float-right":"Returns_float-right__o3Ncc"};